export default __webpack_public_path__ + "static/media/stteresa.b2efb6c4.jpg";